export default {
  transparent: true,
  depthTest: false,
  // depthWrite: false,

  uniforms: {
    screenMin: { value: [-1, -1] },
    screenMax: { value: [1, 1] },
    bounds: { value: [0, 10] }
  },

  vertexShader: `
    precision highp float;

    uniform vec2 screenMin;
    uniform vec2 screenMax; 
    uniform vec2 bounds;   

    attribute float index;
    attribute vec3 instancePosition;
    attribute vec3 color;
    attribute float scale;
    attribute float opacity;

    varying float vRendering;
    varying vec3 vColor;
    varying float vOpacity;

    void main() {

      if (bounds.x <= index && index < bounds.y) {
        vec4 mvPosition = modelViewMatrix * vec4( instancePosition, 1.0 );
        mvPosition.xyz += position * scale;
        gl_Position = projectionMatrix * mvPosition;

        vRendering = 1.0;
        vColor = color;
        vOpacity = opacity;
      } else {
        vRendering = 0.0;
        gl_Position = vec4(0., 0., 0., 0.);
      }
    }
  `,

  fragmentShader: `
    precision highp float;

    varying float vRendering;
    varying vec3 vColor;
    varying float vOpacity;

    void main() {

      if (vRendering < 1.0) {
        discard;
      }

      gl_FragColor = vec4( vColor, vOpacity );
    }
  `
}
